import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SelectIndicatorsInputToolbox from 'Components/selectIndicatorsInputToolbox';
import { makeIndicatorWithId } from 'Selectors/indicatorWithId';
import util from 'Utils';
import * as styles from './selectIndicatorsBundleToolbox.css';

const { filterObject } = util.obj;

const SelectIndicatorsBundleToolbox = ({
  id,
  fullId,
  catHash,
  onIndicatorChange,
  onCharacteristicChange,
  characteristics,
  children,
}) => (
  <div className={styles.bundle} key={id}>
    {children.map((child) => {
      const filtered = filterObject(characteristics, 'indicator', `${child}`);
      const characteristic = filtered[Object.keys(filtered)[0]] || {};
      return (<SelectIndicatorsInputToolbox
        id={child}
        fullId={fullId}
        catHash={catHash}
        key={child}
        onIndicatorChange={onIndicatorChange}
        onCharacteristicChange={onCharacteristicChange}
        characteristics={characteristic}
      />);
    })}
  </div>
);

SelectIndicatorsBundleToolbox.defaultProps = {
  catHash: null,
  fullId: undefined,
};

SelectIndicatorsBundleToolbox.propTypes = {
  id: PropTypes.number.isRequired,
  fullId: PropTypes.string,
  catHash: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.number).isRequired,
  onIndicatorChange: PropTypes.func.isRequired,
  onCharacteristicChange: PropTypes.func.isRequired,
  characteristics: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => makeIndicatorWithId()(state, props);

export default connect(mapStateToProps)(SelectIndicatorsBundleToolbox);

export {
  SelectIndicatorsBundleToolbox,
  mapStateToProps,
};



// WEBPACK FOOTER //
// ./app/components/selectIndicatorsBundleToolbox/index.js